import React, { memo, Fragment, useCallback } from 'react';
import { useTheme, createUseStyles, Text, Icon } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import StepContent from '../StepContent';
import DownloadIcon from '../../icons/DownloadIcon';

import styles from './styles';
const useStyles = createUseStyles(styles, 'DownloadTemplate');

const ITEMS = [
    {
        title: 'cfm_label_requiremente_one',
        subtitle: 'cfm_label_requiremente_one_desc',
    },
    {
        title: 'cfm_label_requiremente_two',
        subtitle: 'cfm_label_requiremente_two_desc',
    },
    {
        title: 'cfm_label_requiremente_three',
        subtitle: 'cfm_label_requiremente_three_desc',
    },
];

const DownloadTemplate = ({ entityName, entityLabel, data, onExport, totals }) => {
    const theme = useTheme();
    const classes = useStyles();
    const { t, logEvent } = useWeb5Context();

    const onDownloadFull = useCallback(() => {
        logEvent({
            event: 'import',
            functionality: 'exportDataFile',
        });
        onExport(entityName, data.importType, true, data.syncNames);
    }, [data, entityName, onExport, logEvent]);

    const onDownloadEmpty = useCallback(() => {
        logEvent({
            event: 'import',
            functionality: 'exportEmptyFile',
        });
        onExport(entityName, data.importType, false, data.syncNames);
    }, [data.importType, data.syncNames, entityName, onExport, logEvent]);

    return (
        <Fragment>
            <div className={classes.stepWrapper}>
                <StepContent>
                    <div className={classes.row}>
                        <div className={classes.rowIcon}>
                            <DownloadIcon />
                        </div>
                        <Text bold>{t('cfm_label_download_general_info')}</Text>
                    </div>
                    <div className={classes.list}>
                        {ITEMS.map((item, index) => (
                            <div key={index} className={classes.listItem}>
                                <Icon
                                    className={classes.listItemIcon}
                                    name="info"
                                    color={theme.colors.actionMajor[500]}
                                />
                                <div>
                                    <Text className={classes.title} bold>
                                        {t(item.title)}
                                    </Text>
                                    <Text>{t(item.subtitle)}</Text>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={classes.boxes}>
                        {!!totals && (
                            <div
                                className={`${classes.box} imports__download-file-data`}
                                onClick={onDownloadFull}
                            >
                                <Icon
                                    className={classes.boxIcon}
                                    color={theme.colors.actionMinor[500]}
                                    name="file"
                                />
                                <div className={classes.boxContext}>
                                    <div className={classes.topBox}>
                                        <Text
                                            color={theme.colors.semantic.info500}
                                            type="subtitle"
                                            bold
                                        >
                                            {t('cfm_label_download_file_with_data')}
                                        </Text>
                                        <Icon
                                            color={theme.colors.actionMinor[500]}
                                            name="downloadAlt"
                                        />
                                    </div>
                                    <Text color={theme.colors.textLight.secondary}>
                                        {t('cfm_label_download_file_with_data_desc')}
                                    </Text>
                                </div>
                            </div>
                        )}
                        <div
                            className={`${classes.box} imports__download-empty-file`}
                            onClick={onDownloadEmpty}
                        >
                            <Icon
                                className={classes.boxIcon}
                                color={theme.colors.actionMinor[500]}
                                name="emptyFile"
                            />
                            <div className={classes.boxContext}>
                                <div className={classes.topBox}>
                                    <Text
                                        color={theme.colors.semantic.info500}
                                        type="subtitle"
                                        bold
                                    >
                                        {t('cfm_label_download_empty_file')}
                                    </Text>
                                    <Icon
                                        color={theme.colors.actionMinor[500]}
                                        name="downloadAlt"
                                    />
                                </div>
                                <Text color={theme.colors.textLight.secondary}>
                                    {t('cfm_label_download_empty_file_desc')}
                                </Text>
                            </div>
                        </div>
                    </div>
                </StepContent>
            </div>
        </Fragment>
    );
};

DownloadTemplate.propTypes = {};

export default memo(DownloadTemplate);
